import { Link } from 'react-router-dom';
import { Check, LayoutGrid } from 'lucide-react';
import { PRODUCTS, PRODUCT_INDEX_ROUTE, STAGES } from '../demo/steps';
import { useVisited } from '../demo/useVisited';

export default function ProductSidebar({ currentRoute }) {
  const { visited } = useVisited();
  const explored = PRODUCTS.filter((p) => visited.has(p.route)).length;
  const percent = Math.round((explored / PRODUCTS.length) * 100);

  return (
    <aside className="psidebar" aria-label="Products">
      <Link
        to={PRODUCT_INDEX_ROUTE}
        className={currentRoute === PRODUCT_INDEX_ROUTE ? 'psidebar__all is-current' : 'psidebar__all'}
        aria-current={currentRoute === PRODUCT_INDEX_ROUTE ? 'page' : undefined}
        data-trapezium-id="shell.sidebar-all-products"
      >
        <LayoutGrid aria-hidden="true" size={18} />
        <span>All products</span>
      </Link>
      <p className="psidebar__explored">
        <strong>{explored}</strong> of {PRODUCTS.length} explored
      </p>
      <div className="psidebar__progress" aria-hidden="true">
        <span style={{ width: `${percent}%` }} />
      </div>

      {STAGES.map((stage) => (
        <div key={stage.key} className="psidebar__group">
          <h2 className="psidebar__stage">
            {stage.number && <span className="psidebar__stage-num">{stage.number}</span>}
            {stage.number && ' '}
            {stage.label}
          </h2>
          <ul>
            {PRODUCTS.filter((p) => p.stage === stage.key).map((p) => {
              const Icon = p.icon;
              const isCurrent = p.route === currentRoute;
              const isVisited = visited.has(p.route);
              return (
                <li key={p.slug}>
                  <Link
                    to={p.route}
                    className={isCurrent ? 'psidebar__item is-current' : 'psidebar__item'}
                    aria-current={isCurrent ? 'page' : undefined}
                    data-trapezium-id={`shell.sidebar-${p.slug}`}
                  >
                    <Icon aria-hidden="true" size={18} className="psidebar__icon" />
                    <span className="psidebar__name">{p.name}</span>
                    {isVisited && !isCurrent && (
                      <>
                        <Check aria-hidden="true" size={16} className="psidebar__tick" />
                        <span className="sr-only">visited</span>
                      </>
                    )}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>
      ))}
    </aside>
  );
}
